/*
 * Child Pages Carousel
 *   - Track translates by one card's width (incl. gap) on prev/next
 *   - Clamps so we never scroll past the last card; disables arrows at the ends
 *   - Recomputes on resize so card width changes (responsive flex-basis) work
 */

function initOne(root) {
    if (root.dataset.wired === '1') return;
    root.dataset.wired = '1';

    const track  = root.querySelector('.js-child-carousel-track');
    const prev   = root.querySelector('.js-child-carousel-prev');
    const next   = root.querySelector('.js-child-carousel-next');
    const cards  = track ? Array.from(track.children) : [];
    if (!track || cards.length < 2) return;

    let index = 0;

    const stepWidth = () => {
        if (cards.length < 2) return cards[0]?.getBoundingClientRect().width || 0;
        const a = cards[0].getBoundingClientRect();
        const b = cards[1].getBoundingClientRect();
        return b.left - a.left;
    };

    const maxIndex = () => {
        const visibleWidth = root.querySelector('.child-carousel__viewport').clientWidth;
        const cardW = cards[0].getBoundingClientRect().width;
        const gap   = stepWidth() - cardW;
        const visibleCount = Math.max(1, Math.floor((visibleWidth + gap) / (cardW + gap)));
        return Math.max(0, cards.length - visibleCount);
    };

    const apply = () => {
        const max = maxIndex();
        if (index > max) index = max;
        if (index < 0)   index = 0;
        track.style.transform = `translateX(${-index * stepWidth()}px)`;
        if (prev) prev.toggleAttribute('disabled', index <= 0);
        if (next) next.toggleAttribute('disabled', index >= max);
    };

    prev?.addEventListener('click', () => { index -= 1; apply(); });
    next?.addEventListener('click', () => { index += 1; apply(); });

    /* ─── Touch swipe (touch events only — no pointer/mouse) ─────── */
    // Listeners are passive so we never call preventDefault; the browser
    // keeps full control of vertical scroll. We only react on touchend
    // and only if the gesture was mostly horizontal — anything else is
    // ignored. No setPointerCapture, no window listeners.
    const SWIPE_MIN = 50; // px of horizontal travel to register a swipe
    let touchStart = null;

    track.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        touchStart = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY,
        };
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
        if (!touchStart) return;
        const t = e.changedTouches[0];
        if (!t) { touchStart = null; return; }
        const dx = t.clientX - touchStart.x;
        const dy = t.clientY - touchStart.y;
        touchStart = null;

        if (Math.abs(dx) < SWIPE_MIN) return;
        if (Math.abs(dx) <= Math.abs(dy)) return; // mostly vertical → ignore

        if (dx < 0) { index += 1; apply(); }
        else        { index -= 1; apply(); }
    }, { passive: true });

    track.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });

    let resizeT = 0;
    window.addEventListener('resize', () => {
        clearTimeout(resizeT);
        resizeT = window.setTimeout(apply, 120);
    });

    requestAnimationFrame(apply);
}

export function initChildCarousels() {
    document.querySelectorAll('.js-child-carousel').forEach(initOne);
}
